export default {
      id: "horizontalMenu-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#horizontalMenu-usage",
      toString: function () {
        return this.url;
      }
    }